<template>
  <el-row>
    <el-col :xs='24' :sm='10' :md='9' :lg='7' :xl='5' v-loading="loadingAssignedApplications">
      <el-card class="newApplicationsMenu">
        <div class="text item">
          <li class="list-group-item" :key="0" @click="toggleNewApplications">
            <el-card>
              <div @click="loadAppsOnAssingDialog(true, dateRange)">
                <!-- <el-badge :value="this.allApplications.length - this.myApplications.length" :max="10"> -->
                <span>Ανάληψη-Αποδέσμευση</span>
                <!-- </el-badge> -->
              </div>
            </el-card>
          </li>
        </div>
      </el-card>
      <applications-lane
        :assignedApplications="assignedApplications"
        :assignedApps="assignedApps"
        @addUniversity='addUniversityEvent'
      >
      </applications-lane>
    </el-col>
    <transition name="el-fade-in-linear">
      <el-col :xs='24' :sm='14' :md='15' :lg='17' :xl='16' v-loading="loadingWorkingApplication">
        <div class="grid-content bg-purple">
          <el-dialog title="Ανάληψη-Αποδέσμευση" :visible.sync="dialogView" width="90%">
            <span>
              <el-form>
                <el-form-item label='Επιλέξτε διάστημα υποβολής'>
                  <el-date-picker
                    v-model="dateRange"
                    type="daterange"
                    range-separator="To"
                    start-placeholder="Start date"
                    format="dd/MM/yyyy"
                    value-format="dd-MM-yyyy"
                    end-placeholder="End date"
                    @change='periodSelected'>
                  </el-date-picker>
                </el-form-item>
              </el-form>
              <div style="text-align: center; margin-top: 5px">
                <el-transfer v-loading="loadingAllApplications"
                  style="margin-top: 5px; text-align: left; display: inline-block"
                  v-model="myApplications"
                  filterable
                  :titles="['Νέες Αιτήσεις', 'Οι Αιτήσεις μου']"
                  :button-texts="['Αποδέσμευση', 'Ανάληψη']"
                  :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }"
                  :data="allApplications"
                  @change="newAssignedApplications"
                  @left-check-change="appsToAssignChanged"
                  @right-check-change="appsToReleaseChanged">
                </el-transfer>
              </div>
              <div style="text-align: center">
                <el-button type="primary"
                  icon="el-icon-error" @click="dialogView = false, toggleNewApplications" plain round>Κλείσιμο
                </el-button>
                <el-button type="success" icon="el-icon-refresh" plain round
                  @click="loadAppsOnAssingDialog(false, dateRange)">Ανανέωση
                </el-button>
              </div>
            </span>
          </el-dialog>
          <el-card class="box-card bg-purple" v-if="showWorkingApplication">
            <div slot="header" class="clearfix">
              <user-app-info></user-app-info>
            </div>
            <div class="text item">
              <el-tabs v-model="activeName" @tab-click="handleClick" :stretch=true :tab-position="tabPosition">
                <el-tab-pane label="Προσωπικά Στοιχεία" name="first">
                  <personal-details :personalDetails="workingApplication.personalDetails"></personal-details>
                </el-tab-pane>
                <el-tab-pane v-if="!isReappraisal && !isPostExam" label="Τίτλος Σπουδών" name="second">
                  <titles :application="workingApplication"></titles>
                </el-tab-pane>
                <el-tab-pane label="Συνυποβολή Τίτλου" name="third"
                  v-if='!isReappraisal && !isPostExam && workingApplication.degreeType === "bachelor" && workingApplication.consideration === true'>
                  <title-consideration :application="workingApplication"></title-consideration>
                </el-tab-pane>
                <el-tab-pane label="Επισυναπτόμενα" name="fourth">
                  <attached-documents
                    :recommendations="recommendations"
                    :userComment="workingApplication.userComment"
                    :attachedDocumentsTable="attachedDocumentsTable"
                    :appId="workingApplication.id"
                    :role="role"
                    :generalCommentProp="generalCommentInDocs"
                    :generalCommentWorking="generalCommentWorking"
                    :neededDocuments="workingApplication.neededDocuments"
                    :isPostExam="isPostExam"
                    @changedAttachedDocs='changedAttachedDocsEvent'
                    @changedGeneralComment="changedGeneralCommentEvent">
                  </attached-documents>
                </el-tab-pane>
                <el-tab-pane label="Ιστορικό" name="fifth" :lazy=true>
                  <history-line :applicationHistory="history"></history-line>
                </el-tab-pane>
                <el-tab-pane label="Αποτέλεσμα Επεξεργασίας" name="sixth">
                  <prechecker-judgment
                    :specialProponents="specialProponents"
                    :recommendations="recommendations"
                    :judgementDocs="judgementDocs"
                    :attachedDocumentsTable="attachedDocumentsTable"
                    :generalCommentWorking="generalCommentWorking"
                    :generalComment="generalComment"
                    :isReappraisal="isReappraisal"
                    :isPostExam="isPostExam"
                    :isSecondReappraisal="isSecondReappraisal">
                  </prechecker-judgment>
                </el-tab-pane>
                <el-tab-pane label="Σχετική αίτηση" name="seventh" v-if="isReappraisal || isPostExam">
                  <relevant-app :relevantApp="workingApplication.relevantApplication"></relevant-app>
              </el-tab-pane>
              <el-tab-pane label="Αρχική επανεξέταση" name="eighth" v-if="isSecondReappraisal">
                  <first-reappraisal :relevantReappraisalApplication="workingApplication.relevantReappraisalApplication"
                  :relevantReappraisalAppl="workingApplication.relevantReappraisalAppl"></first-reappraisal>
              </el-tab-pane>
              </el-tabs>
            </div>
          </el-card>
        </div>
        <application-search v-show="searchVisible"></application-search>
        <search-uni v-show="searchUniVisible"></search-uni>
        <manage-db :addUniversity='addUniversity' v-if='addUniversity'></manage-db>
      </el-col>
    </transition>
  </el-row>
</template>

<script>
import { mapState } from 'vuex'
import PersonalDetails from './common/PersonalDetails'
import Titles from './common/Titles'
import TitleConsideration from './common/TitleConsideration'
import AttachedDocuments from './common/AttachedDocuments'
import HistoryLine from './common/HistoryLine'
import PrecheckerJudgment from './roleSpecific/PrecheckerJudgment'
import ApplicationsLane from './common/ApplicationsLane'
import UserAppInfo from './common/UserAppInfo'
import axios from 'axios'
import dictionary from '../store/dictionary'
import ApplicationSearch from '@/components/common/ApplicationSearch'
import sharedMethods from './common/sharedMethods.js'
import SearchUni from '@/components/common/SearchUni'
import ManageDb from './roleSpecific/ManageDb'
import RelevantApp from './common/RelevantApp'
import FirstReappraisal from './common/FirstReappraisal'

export default {
  name: 'Prechecker',
  components: {
    ManageDb,
    PersonalDetails,
    Titles,
    TitleConsideration,
    AttachedDocuments,
    HistoryLine,
    PrecheckerJudgment,
    ApplicationsLane,
    dictionary,
    UserAppInfo,
    ApplicationSearch,
    SearchUni,
    RelevantApp,
    FirstReappraisal
  },
  mixins: [sharedMethods],
  mounted: function () {
    // this.loadAssignedApplications()
    axios.get(`${this.BASE_URL}/recommendations`)
      .then((response) => {
        this.recommendations = response.data.data
      })
    axios.get(`${this.BASE_URL}/roles/2`)
      .then((response) => {
        this.specialProponents = response.data.data
      }, (err) => {
        this.frontEndError(err)
        this.notifyUser(`Δεν φορτώθηκε η λίστα των Ειδικών Εισηγητών.`)
      })
  },
  data () {
    return {
      addUniversity: false,
      appsToRelease: [],
      appsToAssign: [],
      dateRange: '',
      recommendations: [],
      dialogView: false,
      assignedApps: {
        precheckerW_: [ { id: '1', surname: '', submittedAt: '', degreeType: '' } ],
        precheckerCompensatoryW_: [ { id: '2', surname: '', submittedAt: '', degreeType: '' } ]
      }, // , personalQueue: [{ id: '2', surname: '', createdAt: '', degreeType: '' }]
      role: 'prechecker',
      tabPosition: 'top',
      activeName: 'fourth',
      notificationsDialogVisible: false,
      openNewApplications: false,
      listAssignedApplications: [],
      listPrecheckersApplications: [],
      viewApplication: {},
      myApplications: [],
      allApplications: [],
      loadingAllApplications: false,
      judgementDocs: this.attachedDocumentsTable,
      generalComment: '',
      omotages: null,
      specialProponents: []
    }
  },
  methods: {
    async getApplications (status, range) {
      let url = `${this.BASE_URL}/precheckers/uid/applications`
      if (status) {
        url += '/' + status
      }
      if (Array.isArray(range) && range.length >= 2) {
        url += `?from=${range[0]}&to=${range[1]}`
      }
      try {
        const response = await axios.get(url)
        return response.data.data
      } catch (error) {
        const msg = 'Παρουσιάστηκε πρόβλημα στη φόρτωση των αιτήσεων'
        this.frontEndError(msg)
        console.error('Error fetching apps: ', error)
        return []
      }
    },
    async getUsersApps () {
      return this.getApplications('precheckerW_')
    },
    async getPostExamApps () {
      return this.getApplications('precheckerCompensatoryW_')
    },
    async getAssignedApps () {
      const [usersApps, postExamApps] = await Promise.all([
        this.getUsersApps(),
        this.getPostExamApps()
      ])
      return [...usersApps, ...postExamApps]
    },
    async getAssignableApps (range) {
      return this.getApplications('', range)
    },
    async getAllApps (range) {
      const [assignedApps, assignableApps] = await Promise.all([
        this.getAssignedApps(),
        this.getAssignableApps(range)
      ])
      return [...assignedApps, ...assignableApps]
    },
    addUniversityEvent () {
      this.addUniversity = !this.addUniversity
    },
    loadAssignedApplications () {
      this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
      // .then(response => {
      //   if (response && response.length === 0) {
      //     this.$notify.warning({
      //       title: 'Ειδοποίηση',
      //       message: 'Δεν βρέθηκε καμία αίτηση σας. Αν αυτό δεν ισχύει επικοινωνήστε με τον διαχειριστή',
      //       offset: 100
      //     })
      //   }
      // })
    },
    appLabel (app) {
      const appId = app.id
      let appType = '---'
      const label = `${app.surname} ${app.name.substring(0, 1)}., ${app.submittedAt.substring(0, 10)}, ${app.protocol}`
      if (app.applicationType === 'ΕΠΑΝΕΞΕΤΑΣΗΣ ΑΙΤΗΜΑΤΟΣ ΑΝΑΓΝΩΡΙΣΗΣ ΤΙΤΛΟΥ ΣΠΟΥΔΩΝ') {
        appType = 'Επανεξέταση'
      } else if (app.applicationType === 'ΕΚΔΟΣΗΣ ΠΡΑΞΗΣ ΜΕΤΑ ΑΠΟ ΕΞΕΤΑΣΕΙΣ') {
        appType = 'Μετά από εξετάσεις'
      } else if (app.degreeType) {
        appType = app.degreeType
      }
      return `${appId} - ${appType}, ${label}`
    },
    periodSelected (range) {
      this.loadAppsOnAssingDialog(true, range)
    },
    translate (term) {
      return dictionary[term]
    },
    changedGeneralCommentEvent (comment) {
      this.generalComment = comment
    },
    changedAttachedDocsEvent (docs) {
      let docComments = ''
      docs.forEach(doc => {
        if (doc.precheckerComment) {
          // Todo: this comment must be in English according to language
          docComments +=
            `<p><strong>Τύπος</strong>: ${this.workingApplication.neededDocuments.find(docum => docum.id === doc.type)
              ? this.workingApplication.neededDocuments.find(docum => docum.id === doc.type).grName : 'Εσωτερικός'}, <strong>Όνομα</strong>: ${doc.name}, 
            <strong>Κατάσταση</strong>: ${doc.precheckerChecked ? 'Αποδεκτό' : 'Με εκκρεμότητα'}, 
            <strong>Σχόλιο</strong>: ${doc.precheckerComment}</p>`
        }
      })
      this.judgementDocs = docComments
    },
    async loadMyApplications () {
      const assignedApps = await this.getAssignedApps()
      this.myApplications = assignedApps.map(app => app.id)
    },
    async loadAllApplications (range) {
      const allApps = await this.getAllApps(range)
      this.allApplications = allApps.map(app => ({
        key: app.id,
        label: this.appLabel(app),
        disabled: false
      }))
    },
    async loadAppsOnAssingDialog (openDialog, range) {
      this.loadingAllApplications = true
      try {
        await Promise.all([
          this.loadMyApplications(),
          this.loadAllApplications(range)
        ])
        if (openDialog) {
          this.dialogView = true
        }
      } catch (error) {
        console.log(error)
        this.dialogView = false
      }
      this.loadingAllApplications = false
      // todo: test usersAllApplications for internal use
    },
    appsToReleaseChanged (apps) {
      this.appsToRelease = apps
    },
    appsToAssignChanged (apps) {
      this.appsToAssign = apps
    },
    saveNewApplications (action) {
      axios.put(`${this.BASE_URL}/precheckers/uid/applications`,
        {
          applications: this.myApplications,
          apps: action === 'assign' ? this.appsToAssign : this.appsToRelease,
          action: action
        }
      ).then((response) => {
        this.loadAssignedApplications()
      })
    },
    newAssignedApplications (newApps) {
      // let appNumber = this.myApplications.length - this.assignedApplications.length4
      const appNumber = this.appsToAssign.length > 0 ? this.appsToAssign.length : this.appsToRelease.length
      let action = this.appsToAssign.length > 0 ? 'assign' : 'release'
      // let appsToAssign = this.allApplications.filter(app => app.key === this.myApplications[this.myApplications.length - 1]).map(napp => { return napp.label })
      let warning = action === 'assign'
        ? 'Θα αναλάβετε ' + appNumber +
          (appNumber === 1
            ? ' νέα αίτηση την: ' + this.appsToAssign // + this.allApplications.filter(app => app.key === this.myApplications[this.myApplications.length - 1])
            : ' νέες αιτήσεις τις: ' + this.appsToAssign // + this.allApplications.filter(app => app.key === this.myApplications[this.myApplications.length - 1])
          )
        : 'Θα αποδεσμεύσετε ' + appNumber +
          (appNumber === 1
            ? ' αίτηση την: ' + this.appsToRelease
            : ' αιτήσεις τις: ' + this.appsToRelease
          )
      warning += '. Συνολικά θα έχετε ' + this.myApplications.length + '. Αν δεν συμφωνείτε πατήστε άκυρο!'
      this.$confirm(warning, 'Προσοχή!!!', {
        confirmButtonText: 'Ναι',
        cancelButtonText: 'Άκυρο',
        type: 'warning'
      }).then(() => {
        this.dialogView = false
        this.myApplications = newApps
        this.saveNewApplications(action)
      }).catch(() => {
        this.dialogView = false
        // this.myApplications = this.assignedApplications
        this.myApplications = []
        this.$message({
          type: 'info',
          message: 'Η ανάληψη-αποδέσμευση ακυρώθηκε'
        })
      })
      this.appsToAssign = []
      this.appsToRelease = []
    },
    toggleNewApplications () {
      this.openNewApplications = !this.openNewApplications
    },
    handleClick (tab, event) {
    }
  },
  computed: {
    generalCommentWorking () {
      let history = this.workingApplication.applicationHistory
      if (!history) {
        return null
      }
      return history[history.length - 1].judgment !== null &&
        history[history.length - 1].judgment !== undefined &&
        history[history.length - 1].judgment.pendingReason !== null
        ? history[history.length - 1].judgment.pendingReason.replace(/div/g, 'p')
        : ''
    },
    generalCommentInDocs () {
      let comments = []
      let history = this.workingApplication.applicationHistory.slice(0)
      comments = history[history.length - 1].judgment !== null &&
        history[history.length - 1].judgment !== undefined &&
        history[history.length - 1].judgment.pendingReason !== null
        ? history
          .filter(step => step.applicationStatus === 'precheckerW_')
        : []
      return comments
    },
    attachedDocumentsTable () {
      return this.workingApplication.attachedDocuments.slice(0).map(doc =>
        ({name: doc.name,
          type: doc.type,
          date: doc.date,
          applicantComment: doc.applicantComment,
          precheckerChecked: doc.precheckerChecked,
          precheckerComment: doc.precheckerComment,
          id: doc.id
        })
      )
    },
    isReappraisal () {
      return this.workingApplication.applicationType === 'reappraisal'
    },
    isPostExam () {
      return this.workingApplication.applicationType === 'compensatory'
    },
    isRelevantReappraisal () {
      return this.workingApplication.relevantApplication.applicationType === 'reappraisal'
    },
    isSecondReappraisal () {
      return this.workingApplication.reappraisalSecondDegree
    },
    ...mapState([
      'searchVisible',
      'history',
      'assignedApplications',
      'workingApplication',
      'activeLane',
      'showWorkingApplication',
      'pendingNotifications',
      'loadingAssignedApplications',
      'loadingWorkingApplication',
      'BASE_URL',
      'searchUniVisible'
    ])
  },
  watch: {
    workingApplication: function (newData, oldData) {
      this.activeName = 'fourth'
      this.generalComment = this.generalCommentWorking
    }
  }
}
</script>

<style lang="scss">
.el-transfer-panel .el-transfer-panel__footer {
  text-align: center;
}
.el-transfer-panel {
  width: 500px
}
.newApplicationsMenu {
  background-color: #c8ec3c;
  /*color: #7a9db7;*/
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
.commentText {
  width: 320px;
}
.el-card__body {
  padding: 2px;
}
.el-card {
  margin: 5px;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
// .bg-purple {
//   background: #d3dce6;
// }
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.list-group {
  min-height: 20px;
  overflow: hidden;
}
.list-group-item {
  background-color: #7fa3bb;
  &:hover {
    background-color: #4d7590;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Prechecker.vue